export default __webpack_public_path__ + "static/media/donut-silver.adcda5df.png";